<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<h2>Sale price</h2>

		<div class="mr-5 mt-5">
			<app-select
				label="Net out HST from sale price"
				[(ngModel)]="adjustment.netOutHst"
				(ngModelChange)="onNetOutChange()"
			>
				<option [value]="netOutHstOptions.NO">No</option>
				<option [value]="netOutHstOptions.YES_HST">
					Yes, net out HST rebate
				</option>
				<option [value]="netOutHstOptions.YES_HST_NO_REBATE">
					Yes, net out HST but rebate does not apply
				</option>
				<option [value]="netOutHstOptions.YES_NO_HST">
					Yes, divide sale price by 1.13
				</option>
				<option [value]="netOutHstOptions.NO_SALE_PRICE_HST">
					No, add HST in addition to sale price
				</option>
				<option [value]="netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE">
					No, add HST and rebate in addition to sale price
				</option>
			</app-select>

			<app-input
				type="cents"
				label="Sale price as per agreement {{
					includeHstLabel ? 'including HST' : ''
				}}"
				name="price"
				class="mt-3"
				[startIcon]="ICON.DOLLAR"
				[(ngModel)]="purchasePrice"
				(ngModelChange)="changed()"
			></app-input>
			<ng-container
				*ngIf="
					adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST &&
					adjustment.netOutHst !== netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
				"
			>
				<app-input
					type="cents"
					label="Additional considerations {{
						includeHstLabel ? 'including HST' : ''
					}}"
					name="considerations"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[(ngModel)]="adjustment.considerations"
					(ngModelChange)="changed()"
				></app-input>
				<app-input
					type="cents"
					label="Credits to purchaser {{
						includeHstLabel ? 'including HST' : ''
					}}"
					name="credits"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[(ngModel)]="adjustment.credits"
					(ngModelChange)="changed()"
				></app-input>
				<app-input
					type="cents"
					label="Chattels included in sale price"
					name="chattels"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[(ngModel)]="adjustment.chattels"
					(ngModelChange)="changed()"
				></app-input>
				<app-select
					*ngIf="
						adjustment?.netOutHst === netOutHstOptions.YES_HST ||
						adjustment?.netOutHst === netOutHstOptions.YES_NO_HST ||
						adjustment?.netOutHst === netOutHstOptions.NO
					"
					label="Credit vendor"
					class="mt-3"
					[(ngModel)]="adjustment.creditVendor"
					(ngModelChange)="changed()"
				>
					<option
						*ngFor="let option of vendorOptions; trackBy: trackBycreditVendor"
						[value]="option?.key"
					>
						{{ option?.text }}
					</option>
				</app-select>
				<div *ngIf="showInfoMessage" class="mt-3" [@openClose]>
					<div class="rounded p-2 bg-green-lightest shadow-md flex w-full">
						<app-icon
							[icon]="ICON.INFO"
							class="mr-2 flex items-center"
						></app-icon>
						<p class="whitespace-pre-wrap w-full text-left">
							<ng-container
								*ngIf="
									adjustment.netOutHst === netOutHstOptions.YES_HST &&
									adjustment.creditVendor === 'net'
								"
								>HST on sale price and HST rebate have been automatically added
								as independent adjustments</ng-container
							>

							<ng-container
								*ngIf="
									adjustment.netOutHst === netOutHstOptions.YES_HST_NO_REBATE
								"
								>HST on sale price has been automatically added</ng-container
							>

							<ng-container
								*ngIf="
									adjustment.netOutHst === netOutHstOptions.YES_NO_HST &&
									adjustment.creditVendor === 'net'
								"
								>HST on sale price has been automatically added as independent
								adjustments</ng-container
							>
						</p>
					</div>
				</div>
				<app-input
					type="cents"
					label="Credit Vendor amount"
					name="creditAmount"
					class="mt-3"
					[startIcon]="ICON.DOLLAR"
					[ngModel]="breakdownComponent?.creditAmount"
					[disabled]="true"
				></app-input>
			</ng-container>
			<div
				*ngIf="
					adjustment.netOutHst === netOutHstOptions.NO_SALE_PRICE_HST ||
					adjustment.netOutHst === netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
				"
				class="my-6"
				[@openClose]
			>
				<div class="rounded p-2 bg-green-lightest shadow-md flex w-full">
					<app-icon
						[icon]="ICON.INFO"
						class="mr-2 flex items-center"
					></app-icon>
					<p class="whitespace-pre-wrap w-full text-left">
						<ng-container
							*ngIf="
								adjustment.netOutHst === netOutHstOptions.NO_SALE_PRICE_HST
							"
							>HST on sale price has been automatically added as an independent
							adjustment</ng-container
						>

						<ng-container
							*ngIf="
								adjustment.netOutHst ===
								netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
							"
							>HST on sale price and HST rebate have been automatically added as
							independent adjustments</ng-container
						>
					</p>
				</div>
			</div>
			<div class="mt-3">
				<app-checkbox
					type="clear"
					label="Include all details in document"
					[(ngModel)]="adjustment.details"
				></app-checkbox>
			</div>
		</div>
		<div class="flex justify-between mr-5 mt-5">
			<app-button
				btn="tertiary"
				class="mr-5"
				(click)="cancelModal()"
				size="small"
				>Cancel</app-button
			>
			<app-button (click)="saveModal()" size="small">Save</app-button>
		</div>
	</div>
	<div class="w-1/2">
		<app-sale-price-breakdown
			[purchasePrice]="purchasePrice"
			[adjustment]="adjustment"
			#SalePriceBreakdown
		></app-sale-price-breakdown>
	</div>
</div>
